import { useGetAdvertisemnetBannerDetailQuery } from "@/store/services/misc";
import {
  BadgeProps,
  Box,
  BoxProps,
  Flex,
  FlexProps,
  Heading,
  type HeadingProps,
  Image,
  type ImageProps,
  ListItemProps,
  Skeleton,
  Text,
  TextProps,
} from "@chakra-ui/react";
import { ListProps } from "@chakra-ui/system";
import { HTMLRenderer } from "@picovico/ui";
import { useRouter } from "next/router";

export interface AdvertisementCardProps {
  ContainerProps?: BoxProps;
  HeadingProps?: HeadingProps;
  imageBoxProps?: FlexProps;
  ImageProps?: ImageProps;
  elementProps?:
    | TextProps
    | BoxProps
    | HeadingProps
    | ListProps
    | ListItemProps;
  timelineBoxProps?: BoxProps;
  createdAtBoxProps?: BoxProps;
  createdAtTextProps?: TextProps;
  dateRangeBoxProps?: BoxProps;
  startDateBadgeProps?: BadgeProps;
  endDateBadgeProps?: BadgeProps;
}

export function AdvertismentCard({
  ContainerProps,
  HeadingProps,
  imageBoxProps,
  ImageProps,
  elementProps,
}: AdvertisementCardProps) {
  const router = useRouter();
  const advertisementId = router?.query?.advertisementIdx;
  const { data, isLoading } = useGetAdvertisemnetBannerDetailQuery({
    idx: advertisementId,
  });

  if (isLoading) {
    return (
      <Flex justifyContent={"center"}>
        <Flex
          direction="column"
          mt="4"
          {...ContainerProps}
          gap={4}
          w={{
            base: "100%",
            sm: "100%",
            md: "75%",
          }}
        >
          <Skeleton height="30px" width="250px" rounded={"10px"} />
          <Skeleton height="200px" width="350px" rounded={"10px"} />
          <Skeleton height="60px" width="100%" rounded={"10px"} />
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex direction="column" alignItems="center" mt="2">
      {data ? (
        <Box
          gap={2}
          w={{
            base: "100%",
            sm: "100%",
            md: "80%",
          }}
          // maxH={"60vh"}
          {...ContainerProps}
        >
          <Heading
            as="h1"
            size="lg"
            mb="4"
            textAlign={"start"}
            w="full"
            {...HeadingProps}
          >
            {data?.data?.title || "Advertisement Detail"}
          </Heading>
          <Flex justifyContent={"center"} flex={1} mb={8} {...imageBoxProps}>
            <Image
              src={data.data.image}
              alt={data.data.title}
              w={"100%"}
              h={"100%"}
              rounded="10px"
              // objectFit={"contain"}
              {...ImageProps}
            />
          </Flex>
          {/* <Flex
            justifyContent="space-between"
            alignItems="center"
            py="4"
            borderBottom="1px"
            borderColor="surface.800"
            flexWrap="wrap"
            mb={4}
            gap={4}
            {...timelineBoxProps}
          >
            {data?.data?.start_date && (
              <Flex alignItems="center" gap={2} {...createdAtBoxProps}>
                <Icon as={FiClock} />
                <Text fontSize="sm" fontWeight="medium" {...createdAtTextProps}>
                  Posted on{" "}
                  {format(new Date(data.data.start_date), "MMM dd, yyyy")}
                </Text>
              </Flex>
            )}

            {(data?.data?.start_date || data?.data?.end_date) && (
              <Flex
                gap={4}
                alignItems="center"
                flexWrap="wrap"
                {...dateRangeBoxProps}
              >
                {data?.data?.start_date && (
                  <Badge
                    colorScheme="primary"
                    px={3}
                    py={1}
                    rounded="full"
                    display="flex"
                    alignItems="center"
                    gap={1}
                    {...startDateBadgeProps}
                  >
                    <Icon as={FiCalendar} />
                    Starts:{" "}
                    {format(new Date(data.data.start_date), "MMM dd, yyyy")}
                  </Badge>
                )}
                {data?.data?.end_date && (
                  <Badge
                    colorScheme="primary"
                    px={3}
                    py={1}
                    rounded="full"
                    display="flex"
                    alignItems="center"
                    gap={1}
                    {...endDateBadgeProps}
                  >
                    <Icon as={FiCalendar} />
                    Ends: {format(new Date(data.data.end_date), "MMM dd, yyyy")}
                  </Badge>
                )}
              </Flex>
            )}
          </Flex> */}
          {data?.data.description && (
            <HTMLRenderer
              htmlElement={data?.data.description || ""}
              elementProps={elementProps}
            />
          )}
        </Box>
      ) : (
        <Text {...(elementProps as TextProps)}>No advertisemet</Text>
      )}
    </Flex>
  );
}
